import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ClipboardService  {

     WIDTH_OF_CONTAINER = 871;
     HEIGHT_OF_CONTAINER = 874;

     HEIGHT_OF_FOOTER = 100;

    FOOTER_THEME = "#000000";

    template:HTMLCanvasElement;


    constructor() {
        this.setTemplate();
    }
    setTemplate():void{
        let template = this.getTemplate();
        this.template = template;
    }
    getContext():CanvasRenderingContext2D {
        return this.template.getContext('2d') as CanvasRenderingContext2D;
    }
    getTemplate(): HTMLCanvasElement {
        let containerCanvas  = document.createElement('canvas');
        containerCanvas.width =this.WIDTH_OF_CONTAINER;
        containerCanvas.height = this.HEIGHT_OF_CONTAINER;

        let containerCtx:CanvasRenderingContext2D | null = containerCanvas.getContext('2d');
        if(containerCtx != null){
            // add bg color
            containerCtx.fillStyle = "#ffffff";
            containerCtx.fillRect(0, 0, this.WIDTH_OF_CONTAINER, this.HEIGHT_OF_CONTAINER);



            // Add footer
            containerCtx.fillStyle = this.FOOTER_THEME;
            containerCtx.fillRect(0, this.HEIGHT_OF_CONTAINER - this.HEIGHT_OF_FOOTER, this.WIDTH_OF_CONTAINER, this.HEIGHT_OF_FOOTER);
            let footerLogo = new Image;
            footerLogo.src = "assets/images/KennedysIQ_white.png";
            footerLogo.addEventListener("load", (e) => {
                let yCord:number = (this.HEIGHT_OF_CONTAINER- this.HEIGHT_OF_FOOTER) + (this.HEIGHT_OF_FOOTER- 20)/2;
                let xCord:number = this.WIDTH_OF_CONTAINER - (158 +20)
                containerCtx?.drawImage(footerLogo, xCord, yCord, 158, 30);
            });
           
          
        }

        return containerCanvas;
    }
    addText(texts:string[]){
         // Add label
        let containerCtx = this.getContext();

        containerCtx.fillStyle = this.FOOTER_THEME;
        containerCtx.fillRect(0, this.HEIGHT_OF_CONTAINER - this.HEIGHT_OF_FOOTER, this.WIDTH_OF_CONTAINER- 180, this.HEIGHT_OF_CONTAINER);
     
        containerCtx.fillStyle= "#FFFFFF";
        containerCtx.textAlign = "center";
        let yCord = (this.HEIGHT_OF_CONTAINER - this.HEIGHT_OF_FOOTER) + (this.HEIGHT_OF_FOOTER/2);
        let font = "20px Trebuchet MS";
        let spaceBetweenText = 0;
        let fontSize = 20;
        if(texts.length >= 2){
           font = "18px Trebuchet MS";
           fontSize = 8;
        }
        spaceBetweenText = this.HEIGHT_OF_FOOTER / (texts.length +1);
        yCord = (this.HEIGHT_OF_CONTAINER - this.HEIGHT_OF_FOOTER) + spaceBetweenText;
        containerCtx.font = font;
        for( let text of texts) {
            containerCtx.fillText(text, (this.WIDTH_OF_CONTAINER - 158+20)/2, yCord , this.WIDTH_OF_CONTAINER - 200);
            yCord += (spaceBetweenText + fontSize);
        }
     }
    addChart(elem:HTMLCanvasElement):void {
        let ctx = this.getContext();
        // scale the width and height of canvas to fill the entire space in clipboard
        // Did the image get pixelated when copied in small device ? No idea
        let canvasWidth = elem.width;
        let canvasHeight = elem.height;
        let quotient = (this.HEIGHT_OF_CONTAINER- this.HEIGHT_OF_FOOTER) / canvasHeight ;
        canvasWidth = quotient *canvasWidth;
        canvasHeight = quotient *canvasHeight;

        let xCord = (this.WIDTH_OF_CONTAINER - canvasWidth) / 2;
        let yCord = (this.HEIGHT_OF_CONTAINER -canvasHeight) / 2 - 50;

        // fill white for remove previous contents
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(xCord, yCord, canvasWidth, canvasHeight);

        ctx.drawImage(elem, xCord, yCord, canvasWidth,  canvasHeight);
    }
    copyToClipboard(elem:HTMLCanvasElement, texts:string[]): Observable<boolean> {
        return new Observable(observer => {
            try {
                this.addChart(elem);
                this.addText(texts);
                let image = this.template.toDataURL();
                let a  = document.createElement('a');
                a.download = "audiogram.png";
                a.href = image;
                a.click();
                observer.next(true);
                observer.complete();
              
            } catch(err){
                observer.next(false);
                observer.complete();
            }
            
           
        });        
    }

}